import { createFileRoute } from "@tanstack/react-router";
import { RewardsActivityPage } from "../../features/rewards/pages/rewards-activity-page";

export const Route = createFileRoute("/_layout/rewards/activity")({
  component: RewardsActivityPage,
});
